import _sfc_main from "./index85.js";
/* empty css        */
import _export_sfc from "./index63.js";
const CodSheet = /* @__PURE__ */ _export_sfc(_sfc_main, [["__scopeId", "data-v-40e23667"]]);
export {
  CodSheet as default
};
//# sourceMappingURL=index28.js.map
